import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd'; // Add Spin


const FilteredBook = () => {
  const [providers, setProviders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProviders, setFilteredProviders] = useState([]);
  const [loading, setLoading] = useState(false); // Loader state
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProviders = async () => {
      setLoading(true); // Start loader
      try {
        const res = await axios.get(`${API_BASE}/user/providers`);
        setProviders(res.data);
        setFilteredProviders(res.data);
      } catch (err) {
        console.error('Error fetching providers:', err);
      }
      setLoading(false); // Stop loader
    };
    fetchProviders();
  }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = providers.filter((prov) =>
      `${prov.firstName} ${prov.lastName}`.toLowerCase().includes(term) ||
      prov.category?.toLowerCase().includes(term) ||
      prov.address?.toLowerCase().includes(term) ||
      prov.phoneNumber?.toLowerCase().includes(term)
    );
    setFilteredProviders(filtered);
  }, [searchTerm, providers]);

  const highlightText = (text = '', term) => {
    if (!term) return text;
    const regex = new RegExp(`(${term})`, 'gi');
    return text.split(regex).map((part, i) =>
      part.toLowerCase() === term.toLowerCase() ? (
        <mark key={i} className="bg-yellow-300 px-1 rounded">{part}</mark>
      ) : (
        part
      )
    );
  };
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <Spin spinning={loading} tip="Processing...">
      <div className="min-h-screen bg-gray-100 py-10 px-5">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Service Providers</h2>

          {/* Search bar */}
          <div className="mb-8 flex justify-center">
            <input
              type="text"
              placeholder="Search by name, category, phone, or address..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full md:w-1/2 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-red-500"
            />
          </div>

          {/* Providers Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProviders.length > 0 ? (
              filteredProviders.map((prov) => (
                <div
                  key={prov._id}
                  className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                >
                  {/* Avatar */}
                  <div className="flex justify-center mb-4">
                    {prov.avatar ? (
                      <img
                        src={prov.avatar}
                        alt={`${prov.firstName}'s avatar`}
                        className="w-32 h-32 rounded-full object-cover border"
                      />
                    ) : (
                      <div className="w-32 h-32 flex items-center justify-center bg-gray-200 rounded-full text-gray-600 text-sm">
                        No Avatar
                      </div>
                    )}
                  </div>

                  {/* Name */}
                  <h3 className="text-xl font-semibold text-center mb-2">
                    {highlightText(`${prov.firstName} ${prov.lastName}`, searchTerm)}
                  </h3>

                  {/* Provider Info */}
                  <div className="text-sm text-gray-700 space-y-1">
                    <p><strong>ID:</strong> <span className="break-all">{prov._id}</span></p>
                    <p><strong>Category:</strong> {highlightText(prov.category || 'N/A', searchTerm)}</p>
                    {prov.address && <p><strong>Address:</strong> {highlightText(prov.address, searchTerm)}</p>}
                    {prov.phoneNumber && <p><strong>Phone:</strong> {highlightText(prov.phoneNumber, searchTerm)}</p>}
                  </div>

                  {/* Buttons */}
                  <div className="mt-4 flex justify-between">
                    <button
                      onClick={() =>
                        navigate("/book", {
                          state: {
                            providerId: prov._id,
                            providerCategory: prov.category,
                          },
                        })
                      }
                      className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md text-sm"
                    >
                      Book
                    </button>
                    <button
                      onClick={() => navigate(`/viewGallery/${prov._id}`)}
                      className="bg-gray-700 hover:bg-gray-800 text-white px-4 py-2 rounded-md text-sm"
                    >
                      Profile Gallery
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-500 col-span-full">No providers found.</p>
            )}
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default FilteredBook;
